export default __webpack_public_path__ + "static/campaign-fi-82a1b03551d7958bd85b34973e751a5f.mp4";